
import React from 'react';
import { 
  User, 
  Calendar, 
  Settings, 
  Home, 
  Mail, 
  Lock, 
  LogIn, 
  LogOut, 
  PlusCircle, 
  AlertCircle,
  Check,
  X,
  ChevronsUpDown,
  Clock,
  MoreVertical,
  Circle
} from 'lucide-react';

const Icons = {
  user: User,
  calendar: Calendar,
  settings: Settings,
  home: Home,
  mail: Mail,
  lock: Lock,
  login: LogIn,
  logout: LogOut,
  add: PlusCircle,
  alert: AlertCircle,
  check: Check,
  close: X,
  chevronUpDown: ChevronsUpDown,
  clock: Clock,
  more: MoreVertical,
  circle: Circle, // Add the Circle icon
  
  // Add Google icon
  google: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" fill="none" />
      <path d="M18.6 11.43H12v2.14h3.82a3.26 3.26 0 01-3.26 3.26 3.43 3.43 0 110-6.86c.87 0 1.66.31 2.28.83l1.5-1.5A5.85 5.85 0 0012 7.5a5.71 5.71 0 105.71 5.71c0-.25-.03-.5-.07-.78l-4.11.01z" />
    </svg>
  ),
  
  logo: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M8 14s1.5 2 4 2 4-2 4-2" />
      <line x1="9" y1="9" x2="9.01" y2="9" />
      <line x1="15" y1="9" x2="15.01" y2="9" />
    </svg>
  ),
  
  spinner: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="animate-spin"
      {...props}
    >
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
  ),
};

export default Icons;
